import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import useTranslation from '../../../utils/translation'

const Container = styled.div`
  max-width: 550px;
  margin: 0px auto;
`

const Heading = styled.h1`
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-family: ${theme('cancel.step4.heading.fontFamily')};
  text-align: center;
  margin: ${theme('cancel.step4.heading.margin')};
  max-width: 475px;
  font-size: ${theme('cancel.step4.heading.fontSize.mobile')};
  line-height: ${theme('cancel.step4.heading.fontSize.lineHeight')};
  font-weight: ${theme('cancel.step4.heading.fontWeight')};
  ${(props) => props.theme.media.min.sm`
    font-size: ${theme('cancel.step4.heading.fontSize.desktop')};
    line-height: ${theme('cancel.step4.heading.fontSize.lineHeight')};
  `}
`

const Link = styled.a`
  font-family: ${theme('typography.paragraph.fontFamily')};
  background-color: ${theme('cancel.step4.link.backgroundColor')};
  color: #ffffff;
  text-decoration: none;
  padding: ${(props) =>
    theme('cancel.step4.link.padding')(props) || '13px 30px 13px 30px'};
  font-size: 16px;
  border-radius: ${theme('cancel.step4.link.borderRadius')};
  width: 100%;
  font-weight: ${(props) =>
    theme('cancel.step4.link.fontWeight')(props) || 500};
  text-transform: ${(props) =>
    theme('cancel.step4.link.textTransform')(props) || 'none'};
  display: block;
  text-align: center;
  cursor: pointer;
  :hover {
    opacity: 0.9;
  }
`

const CancelStep4 = () => {
  const t = useTranslation('cancel.step4')
  return (
    <Container>
      <Heading>{t('heading')}</Heading>
      <Link href={window.location.origin}>{t('buttonText')}</Link>
    </Container>
  )
}

export default CancelStep4
